import type { NdaWaitingOn, NdaPhase, NdaAttention } from '../types';

/**
 * Pure display mappers for the NDA tab. Kept out of the component so they're
 * unit-testable. PR-1: waiting-on is the event-sourced projection facet
 * (system|ember|counterparty|none); the legacy peter/associate/done vocab is
 * retired.
 */

export function waitingOnLabel(waitingOn: NdaWaitingOn | null): string {
  switch (waitingOn) {
    case 'ember':
      return 'Waiting on Ember';
    case 'counterparty':
      return 'Waiting on counterparty';
    case 'system':
      return 'Processing';
    case 'none':
      return '—';
    default:
      return '—';
  }
}

export function phaseLabel(phase: NdaPhase | null): string {
  switch (phase) {
    case 'intake':
      return 'Intake';
    case 'first_review':
      return 'First review';
    case 'negotiation':
      return 'Negotiation';
    case 'execution':
      return 'Execution';
    case 'complete':
      return 'Complete';
    default:
      return '—';
  }
}

export function attentionLabel(attention: NdaAttention | null): string {
  switch (attention) {
    case 'needs_attention':
      return 'Needs attention';
    case 'blocked':
      return 'Blocked';
    case 'clear':
    default:
      return 'Clear';
  }
}

/**
 * "2/3 resolved" — backend sends open + total must-haves on the latest
 * turn; resolved = total - open. No must-haves at all renders an em dash.
 */
export function mustHaveProgressLabel(open: number, total: number): string {
  if (total <= 0) return '—';
  const resolved = Math.max(0, total - open);
  return `${resolved}/${total} resolved`;
}
